import type { ServiceCode, ServiceType } from '@common/enums';
import type { IEpisodeCategory } from '@common/interfaces';
import type {
    IAdminProcess,
    IAdminProcessesListSearchState,
    NewOrOldAdminProcess,
} from '@frontend/components/interfaces/adminProcessesList';
import { getSelectedLanguage } from '@frontend/translate';

export function getCleanAdminProcessesSearchState() {
    const cleanSearchState: IAdminProcessesListSearchState = {
        endCreationDate: null,
        episodeCategoryId: null,
        field: null,
        includeTotal: false,
        itemsPerPage: 10,
        page: 1,
        serviceId: null,
        serviceType: null,
        showAutomaticRightsOnly: false,
        startCreationDate: null,
        statusLabel: null,
        text: '',
    };

    return cleanSearchState;
}

export interface IService {
    code: ServiceCode;
    episodeCategoryId: string;
    id: string;
    name: string;
    serviceType: ServiceType;
}

export function getServiceFilterValue(serviceId: string, services: IService[]) {
    const correctService = services.find((service) => service.id === serviceId);

    return {
        label: correctService && `${correctService.code} - ${correctService.name}`,
        value: serviceId,
    };
}

export function getSelectServiceOptions(
    services: IService[],
    serviceType: ServiceType | null,
    episodeCategoryId: string | null
) {
    return services
        .filter((service) => service.serviceType === serviceType || serviceType === null)
        .filter((service) => service.episodeCategoryId === episodeCategoryId || episodeCategoryId === null)
        .map((service) => ({ label: `${service.code} - ${service.name}`, value: service.id }));
}

export function getEpisodeCategoryOptions(episodeCategoriesArray: IEpisodeCategory[]) {
    const language = getSelectedLanguage();

    return episodeCategoriesArray.map((episodeCategory) => ({
        label: language.episodeCategoryEnum[episodeCategory.name],
        value: episodeCategory.id,
    }));
}

export function getEpisodeCategoryFilterValue(episodeCategoryId: string, episodeCategories: IEpisodeCategory[]) {
    const language = getSelectedLanguage();

    const episodeCategory = episodeCategories.find((category) => category.id === episodeCategoryId);
    if (episodeCategory) {
        return {
            label: episodeCategory && language.episodeCategoryEnum[episodeCategory.name],
            value: episodeCategoryId,
        };
    }
}

export function isAdminProcess(process: NewOrOldAdminProcess): process is IAdminProcess {
    return process.processId !== undefined;
}
